import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import ColorsComponent from './colors';
import ComponentsHTML from './components.html';
import FormsComponent from './forms';
import GridComponent from './grid';
import LayoutHTML from './layout.html';
import NotesComponent from './notes';
import TypographyHTML from './typography.html';

class Component extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabs: {
                typography: [
                    'headings',
                    'paragraphs',
                    'alignment',
                    'transformation',
                ],
                colors: [
                    'colors',
                    'CSS',
                    'SCSS',
                ],
                grid: [
                    'basics',
                    'sizes',
                    'responsive',
                    'options',
                ],
                /*
                forms: [
                    'inputs',
                    'dropdowns',
                    'radios',
                    'checkboxes',
                    'buttons',
                ],
                */
                layout: [
                    'visibility',
                    'padding-and-margin',
                    'wells',
                ],
                components: [
                    'tarot-readings',
                    'logged-in-out',
                    //'daily-links',
                    //'nav-dropdown',
                    'promo-messages',
                    'zodiac-sign-picker',
                    'chinese-zodiac-signs',
                    'chinese-zodiac-sign-datepicker',
                    'planet-tracker',
                    'product-carousel',
                ],
                //notes: [],
            },
        };

        this.page = props.page || 'typography';
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.route != this.props.route) {
            return true;
        }

        return false;
    }

    render() {
        return (
            <content-styles>
                <header>
                    {this.renderNav()}
                </header>
                {this.renderContent()}
            </content-styles>
        );
    }

    renderNav = () => {
        return [
            <div className='nav'>
                <ul>
                    {Object.keys(this.state.tabs).map(tab => {
                        return (
                            <li className={tab == this.page ? 'is-active' : ''}>
                                <a href={`/content-styles/${tab}`}>{tab}</a>
                            </li>
                        );
                    })}
                </ul>
            </div>,
            this.renderSubnav(),
        ];
    }

    renderSubnav = () => {
        if (this.state.tabs[this.page] && this.state.tabs[this.page].length) {
            return (
                <div className='subnav'>
                    <ul>
                        {this.state.tabs[this.page].map(tab => {
                            return (
                                <li className={tab == this.props.route ? 'is-active' : ''}>
                                    <a href={`#${tab}`}>{tab.replace(/-/g, ' ')}</a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            );
        }

        return null;
    }

    renderContent = () => {
        let Content = <div dangerouslySetInnerHTML={{__html: TypographyHTML}} />;

        if (this.page == 'colors') {
            Content = <ColorsComponent />;
        } else if (this.page == 'components') {
            Content = <div dangerouslySetInnerHTML={{__html: ComponentsHTML}} />;
        } else if (this.page == 'forms') {
            Content = <FormsComponent />;
        } else if (this.page == 'grid') {
            Content = <GridComponent />;
        } else if (this.page == 'layout') {
            Content = <div dangerouslySetInnerHTML={{__html: LayoutHTML}} />;
        } else if (this.page == 'notes') {
            Content = <NotesComponent />;
        }

        return Content;
    }
}

const mapStateToProps = (state) => ({
    route: state.route,
});

export default connect(mapStateToProps)(Component);